import React from 'react';
import { Box, Typography, Container, Grid } from '@mui/material';
import FeatureCard from '../components/FeatureCard';
import { FaFileMedical } from "react-icons/fa";
import { GiMeditation } from "react-icons/gi";
import { FaBook } from 'react-icons/fa';
import { useState } from 'react';




function Features() {

  return (
    <Box sx={{ py: 5 }}>
      <Container maxWidth="lg">
        <Typography variant="h3" align="center" gutterBottom>
          Discover Our Features
        </Typography>
        <Grid container spacing={4} sx={{ mt: 2 }}>
          <Grid item xs={12} md={4}>
            <FeatureCard
              icon={<FaFileMedical />}
              title="Log Dream"
              description="Enter your dream details and receive insightful interpretations powered by AI."
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <FeatureCard
              icon={<FaBook />}
              title="Dream Diary"
              description="Keep a personal diary of your dreams and track patterns over time."
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <FeatureCard
              icon={<GiMeditation />}
              title="Meditation"
              description="Use our curated meditations or create your own tailored sessions."
            />
          </Grid>
        </Grid>
      </Container>

     

    </Box>
  );
}




export default Features;